const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;
const GOOGLE_AUTH_URL = process.env.REACT_APP_EMERGENT_AUTH_URL;
if (!API_BASE_URL) throw new Error('REACT_APP_BACKEND_URL is required');
if (!GOOGLE_AUTH_URL) throw new Error('REACT_APP_EMERGENT_AUTH_URL is required');

const request = async (path, options = {}) => {
  try {
    const response = await fetch(`${API_BASE_URL}${path}`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
      ...options,
    });
    const data = await response.json().catch(() => null);
    if (!response.ok) {
      return { ok: false, status: response.status, error: data?.detail || 'Request failed' };
    }
    return { ok: true, data };
  } catch {
    return { ok: false, status: 0, error: 'Unable to reach the server' };
  }
};

export const beginGoogleAdminLogin = () => {
  if (!GOOGLE_AUTH_URL) return { ok: false, error: 'Google login is not configured' };
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirect = window.location.origin + '/admin';
  window.location.href = `${GOOGLE_AUTH_URL}?redirect=${encodeURIComponent(redirect)}`;
  return { ok: true };
};

export const exchangeAdminSession = (sessionId) => request('/api/auth/session', {
  method: 'POST',
  body: JSON.stringify({ session_id: sessionId }),
});

export const getCurrentAdmin = () => request('/api/auth/me');

export const logoutAdmin = () => request('/api/auth/logout', { method: 'POST' });

export const getAdminDownloads = () => request('/api/admin/downloads');

export const downloadAdminModule = async (download) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/downloads/${download.id}`, {
      credentials: 'include',
    });
    if (!response.ok) {
      const data = await response.json().catch(() => null);
      return { ok: false, error: data?.detail || 'Download failed' };
    }
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = download.filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(objectUrl);
    return { ok: true };
  } catch {
    return { ok: false, error: 'Unable to download this module' };
  }
};
